import React from "react";

const Footer = () => {
  return (
    <footer className="flex text-center justify-center px-4 py-6">
      <p className="text-sm">
        Copyright 2021 • All Rights Reserved Travel.Lah by M. Daffa Badran
        Thoriq
      </p>
    </footer>
  );
};

export default Footer;
